import { Component } from '@angular/core';
import { LoaderService } from '../services/loader-service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-loader',
    imports: [MatProgressSpinnerModule, CommonModule],
    template: `
    @if (isLoading$ | async) {
      <div class="loader-overlay">
        <mat-spinner></mat-spinner>
      </div>
    }
    `,
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  isLoading$ = this.loaderService.isLoading$;

  constructor(private loaderService: LoaderService) {}
}
